"use client";

import HistoryIcon from "@mui/icons-material/History";
import SettingsIcon from "@mui/icons-material/Settings";
import { Menu } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { IServiceInterface } from "@/interfaces/service-interface.interface";
import { ServiceInterfaceMessages } from "@/messages/service-interface/service-interface.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

type Props = {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: ServiceInterfaceMessages;
  selected: IServiceInterface;
  onOpenSettings: (item: IServiceInterface) => void;
};

export function ServiceInterfacePopover({ isOpen, anchorEl, onClose, messages, selected, onOpenSettings }: Props) {
  const router = useNavigate();
  const { lang } = useLanguage();

  const handleOpenSettings = () => {
    onOpenSettings(selected);
  };

  const handleOpenLogs = () => {
    onClose();
    router(ROUTE_URLS.integrationLogs(lang, selected.id), {
      state: {
        platformDisplayName:
          selected.platformDisplayName?.trim() ||
          selected.platformName?.trim() ||
          messages.internalPlatformLabel,
        serviceKey: selected.serviceKey,
      },
    });
  };

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <NotificationItem
        icon={<SettingsIcon />}
        onClick={handleOpenSettings}
        title={messages.settingsPopover}
      />
      <NotificationItem
        icon={<HistoryIcon />}
        onClick={handleOpenLogs}
        title={messages.logsPopover}
      />
    </Menu>
  );
}
